import { createSelector } from '@reduxjs/toolkit';

import { selectEtazhiBlackFridayPromoOffersData } from './selectEtazhiBlackFridayPromoOffersData';
import { getIsRSEnabled } from './utils/getIsRSEnabled';

export const selectIsEtazhiBlackFridayPromoOffersEnabled = createSelector(
  selectEtazhiBlackFridayPromoOffersData,
  promoOffersData => {
    return getIsRSEnabled(promoOffersData);
  },
);
